import { useFetchApiList } from '@stagapps/redux-utils'
import { Descriptions, Space, Tag } from 'antd'
import apiCall from 'app/apiCalls/fundAccount'
import MetaDecorator from 'common/layout/MetaDecorator'
import PageTitle from 'common/layout/PageTitle'
import ErrorMessage from 'common/ui/ErrorMessage'
import LoadingSpinner from 'common/ui/LoadingSpinner'
import UICard from 'common/ui/display/UICard'
import { fundAccountStatusColors } from 'data/fundAccount'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

const { Item } = Descriptions

const PAGE_TITLE = 'Công ty quỹ đã mở tài khoản giao dịch'

function FundAccountDetailPage() {
  const { id } = useParams()
  const {
    data: item = {},
    load: fetchItem,
    isLoading,
    paging,
    error
  } = useFetchApiList(apiCall.detail, { resourceName: 'data' })

  useEffect(() => {
    fetchItem({ id })
  }, [])

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4">
        <LoadingSpinner />
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex flex-col gap-4">
        <ErrorMessage errors={error} />
      </div>
    )
  }


            const {logo, fund_manager_name,  status,status_label,
              full_name,
trading_code,
email,
phone,
id_number,
id_issue_date,
id_issue_place,
bank_name,
bank_branch_name,
bank_account_number,
bank_account_name,
trading_account_manager
            } = item || {}

  return (
    <div className="flex flex-col gap-4">
      <MetaDecorator title={PAGE_TITLE} />
      <PageTitle
        title={`Tài khoản giao dịch ${trading_code?.toUpperCase()}`}
      />
      <UICard title={'Thông tin chi tiết'}>
        <Descriptions bordered column={1}>
          <Item label="Tổ chức phát hành">
            <Space>
              <img width={50} src={logo} alt={trading_account_manager} />
              <span>{trading_account_manager}</span>
            </Space>
          </Item>
          <Item label="Trạng thái">
            <Tag color={fundAccountStatusColors[status]}>
              {status_label}
            </Tag>
          </Item>
          <Item label="Tên nhà đầu tư">{full_name}</Item>
          <Item label="Số tài khoản giao dịch">{trading_code}</Item>
          <Item label="Email đăng ký">{email}</Item>
          <Item label="Điện thoại đăng ký">{phone}</Item>
          <Item label="Số định danh">{id_number}</Item>
          <Item label="Ngày cấp">{id_issue_date}</Item>
          <Item label="Nơi cấp">{id_issue_place}</Item>
          <Item label="Tên ngân hàng">{bank_name}</Item>
          <Item label="Chi nhánh">{bank_branch_name}</Item>
          <Item label="Số tài khoản">{bank_account_number}</Item>
          <Item label="Tên tài khoản">{bank_account_name}</Item>
        </Descriptions>
      </UICard>
    </div>
  )
}

export default FundAccountDetailPage
